import { render, staticRenderFns } from "./ProductDeliveryInfo.vue?vue&type=template&id=53c3ed10&scoped=true"
import script from "./ProductDeliveryInfo.vue?vue&type=script&lang=js"
export * from "./ProductDeliveryInfo.vue?vue&type=script&lang=js"
import style0 from "./ProductDeliveryInfo.vue?vue&type=style&index=0&id=53c3ed10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c3ed10",
  null
  
)

export default component.exports